import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('config-url-defer-iv');
	},
};
